import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "./FilterModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllPosts, setFilters } from "reducer/admin/postMonitoringSlice";
import { flagStatusOptions, statusOptions, userTypeOptions } from "constants/constants";
import SelectCustom from "components/common/Select/Select";
import { selectDropdownStyles } from "../constants";

const FilterModal = ({ onClose, searchTerm }) => {

  const dispatch = useDispatch();

  const { filters } = useSelector(
    (state) => state.posts
  );

  const formDropdownFields = [
    { label: "User Type", key: "userType", options: userTypeOptions },
    { label: "Status", key: "status", options: statusOptions },
    { label: "Flag Status", key: "flaggedStatus", options: flagStatusOptions }
  ];

  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fromDate: filters.fromDate?.split("T")[0] || "",
      toDate: filters.toDate?.split("T")[0] || "",
      userType: filters.userType || null,
      status: filters.status || null,
      flaggedStatus: filters.flaggedStatus || null,
    }
  });

  const watchToDate = watch("toDate");

  useEffect(() => {
    // Disable scroll when modal is open
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const resetAll = () => {
    reset({
      fromDate: "",
      toDate: "",
      status: "",
      flaggedStatus: "",
    });
    dispatch(setFilters({ fromDate: "", toDate: "", status: "", flaggedStatus: "" }));
    dispatch(getAllPosts({ pageSelected: 1, search: searchTerm, filters: {} }));
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : "",
      toDate: data.toDate ? new Date(data.toDate).toISOString() : "",
    };
    dispatch(setFilters(payload));
    dispatch(getAllPosts({ pageSelected: 1, search: searchTerm, filters: payload }));
    onClose();
  };

  const isFilterActive = () => {
    const values = watch();
    return values.fromDate || values.toDate || values.userType || values.status || values.flaggedStatus;
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <form className={styles.modal} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.dragBar}></div>
        <p className={styles.title}>Filter by:</p>

        <div className={styles.section}>
          <div className={styles.dropdownLabel}>
            <span>Date Range</span>
            <button
              type="button"
              onClick={() => {
                setValue("fromDate", "");
                setValue("toDate", "");
              }}
            >
              Reset
            </button>
          </div>
          <div className={styles.dateInputs}>
            <input
              type="date"
              {...register("fromDate", {
                validate: (from) => {
                  const to = watchToDate;
                  return !from || !to || new Date(from) <= new Date(to) || "please select a valid date range";
                },
              })}
            />
            <input
              type="date"
              {...register("toDate", {
                // validate: (to) => {
                //   const from = watchFromDate;
                //   return !to || !from || new Date(from) <= new Date(to) || "To Date should be after From Date";
                // },
              })}
            />
          </div>
          {errors.fromDate && <p className={styles.error}>{errors.fromDate.message}</p>}
          {errors.toDate && <p className={styles.error}>{errors.toDate.message}</p>}
        </div>

        {formDropdownFields?.map(({ label, key, options }) => (
          <div className={styles.dropdownWrapper} key={key}>
            <div className={styles.dropdownLabel}>
              <span>{label}</span>
              <button
                type="button"
                onClick={() => {
                  setValue(key, "");
                }}
              >
                Reset
              </button>
            </div>
            <Controller
              name={key}
              control={control}
              render={({ field }) => {
                let selectedOption;
                if (field.value) {
                  selectedOption = options.find(option => option.value === field.value);
                } else {
                  selectedOption = ""
                }
                return (
                  <SelectCustom
                    {...field}
                    options={options}
                    value={selectedOption}
                    styles={selectDropdownStyles()}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption?.value);
                    }}
                  />
                );
              }}
            />
          </div>
        ))}

        <div className={styles.buttonGroup}>
          <button
            type="button"
            className={`${styles.resetBtn} ${!isFilterActive() ? styles.disabled : ""}`}
            onClick={resetAll}
            disabled={!isFilterActive()}
          >
            Reset All
          </button>
          <button
            type="submit"
            className={`${styles.applyBtn} ${!isFilterActive() ? styles.disabled : ""}`}
            disabled={!isFilterActive()}
          >
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterModal;
